(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footyup-city-store"] && !Shopify.designMode) return;
  try {
    
function footyUpOpenCity(event){const link=event.target.closest('[data-fu-city]');if(!link)return;const detail=document.getElementById(link.hash.slice(1));if(detail){detail.open=true;}}
document.addEventListener('click',footyUpOpenCity);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goat-video-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('goat-hero-loop')) {
  customElements.define('goat-hero-loop', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.video = this.querySelector('video');
      this.graphic = this.querySelector('.goat-video-hero__fallback img');
      this.slogan = this.querySelector('.goat-video-hero__slogan p');
      this.sloganDuration = (Number(this.dataset.sloganSeconds) || 5) * 1000;
      this.button = this.querySelector('.goat-video-hero__toggle');
      this.musicButton = this.querySelector('.goat-video-hero__music');
      this.musicEnabled = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.duration = (Number(this.dataset.imageSeconds) || 7) * 1000;
      this.manualPause = this.motion.matches;
      this.stage = 'slogan';
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.loop = false;
      this.video.addEventListener('ended', () => this.showImage(), options);
      this.video.addEventListener('playing', () => {
        if (this.manualPause || document.hidden) { this.video.pause(); return; }
        this.dataset.phase = 'video';
        this.zoom?.cancel();
      }, options);
      this.video.addEventListener('error', () => {
        this.manualPause = true;
        this.dataset.phase = 'image';
        this.updateButton();
      }, options);
      this.button.addEventListener('click', () => {
        this.manualPause = !this.manualPause;
        if (this.manualPause) this.pause(); else this.resume();
        this.updateButton();
      }, options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause(); else if (!this.manualPause) this.resume();
      }, options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) {
          this.manualPause = true;
          this.pause();
          this.dataset.phase = 'image';
          this.updateButton();
        }
      }, options);
      this.musicButton.hidden = false;
      this.musicButton.addEventListener('click', () => {
        this.musicEnabled = !this.musicEnabled;
        this.syncMusic();
        if (this.musicEnabled) {
          this.manualPause = false;
          if (this.stage !== 'video') {
            this.zoom?.cancel();
            this.video.currentTime = 0;
            this.playVideo();
          } else this.resume();
          this.updateButton();
        }
      }, options);
      this.button.hidden = false;
      this.updateButton();
      this.showSlogan();
    }
    syncMusic() {
      this.video.muted = !this.musicEnabled;
      this.musicButton.textContent = this.musicEnabled ? this.dataset.musicOff : this.dataset.musicOn;
      this.musicButton.setAttribute('aria-pressed', String(this.musicEnabled));
    }
    updateButton() {
      this.button.textContent = this.manualPause ? this.dataset.playLabel : this.dataset.pauseLabel;
    }
    playVideo() {
      this.stage = 'video';
      this.syncMusic();
      const playing = this.video.play();
      if (playing) playing.catch(() => {
        if (!this.isConnected || this.manualPause || document.hidden) return;
        this.manualPause = true;
        this.dataset.phase = 'image';
        this.updateButton();
      });
    }
    showImage() {
      this.stage = 'image';
      this.dataset.phase = 'image';
      this.zoom?.cancel();
      this.zoom = this.graphic.animate(
        [{ transform: 'scale(1)' }, { transform: this.motion.matches ? 'scale(1)' : 'scale(1.12)' }],
        { duration: this.duration, easing: 'ease-in-out', fill: 'forwards' }
      );
      this.zoom.onfinish = () => {
        if (this.manualPause || document.hidden) return;
        this.showSlogan();
      };
      if (this.manualPause || document.hidden) this.zoom.pause();
    }
    showSlogan() {
      this.video.pause();
      this.stage = 'slogan';
      this.dataset.phase = 'slogan';
      this.zoom?.cancel();
      const frames = this.motion.matches
        ? [{ opacity: 1 }, { opacity: 1 }]
        : [{ opacity: 0, offset: 0 }, { opacity: 1, offset: .7 }, { opacity: 1, offset: 1 }];
      this.zoom = this.slogan.animate(frames, { duration: this.sloganDuration, easing: 'ease-in-out', fill: 'forwards' });
      this.zoom.onfinish = () => {
        if (this.manualPause || document.hidden) return;
        this.video.currentTime = 0;
        this.playVideo();
      };
      if (this.manualPause || document.hidden) this.zoom.pause();
    }
    pause() { this.video.pause(); this.zoom?.pause(); }
    resume() {
      this.syncMusic();
      if (document.hidden) return;
      if ((this.stage === 'image' || this.stage === 'slogan') && this.zoom) {
        if (this.zoom.playState === 'finished') { this.zoom.onfinish(); }
        else this.zoom.play();
      } else this.playVideo();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.video?.pause();
      this.zoom?.cancel();
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
